import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SkeletonTable from "../../components/table/SkeletonTable";
import columns from "../../columns/activity/activity";
import moment from "moment";
import { GetActivityApi } from "../../api/request/activity/activity";
import UserAvatar from "../../components/common/UserAvatar";
import Search from "../../components/common/Search";
import YearPicker from "../../components/common/YearPicker";

const Activity = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [selectedYear, setSelectedYear] = useState(moment().year());

  const updatedColumns = [
    // {
    //   title: "User",
    //   dataIndex: "userDetails",
    //   render: (value) => (value ? value : "--"),
    // },
    ...columns,
  ];

  const getActivity = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetActivityApi({
        year: selectedYear,
      });

      setData(
        data?.data?.map((item) => {
          return {
            ...item,
            userDetails: <UserAvatar data={item?.user} />,
            created_at: item?.created_at
              ? moment(item?.created_at).format("lll")
              : "--",
            message: (
              <div
                className="w-[300px] truncate"
                title={item?.activity_message}
              >
                {item?.activity_message}
              </div>
            ),
          };
        }),
      );
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleRedirect = (record) => {
    const redirectName = record?.activity?.toLowerCase();
    if (redirectName === "upload") {
      if (record?.type_label?.toLowerCase() === "client") {
        navigate(`/client/${record?.user?.id}`, {
          state: {
            setTab: true,
          },
        });
      }
    } else if (redirectName === "verify doc") navigate("/verify_doc");
    else if (redirectName === "prepare tax") navigate("/prepare_tax");
    else if (redirectName === "review tax") navigate("/review_tax");
    else if (redirectName === "follow up") navigate("/follow_up");
    else if (redirectName === "e-file") navigate("/e_file");
    else if (redirectName === "invoice") navigate("/report/payment");
  };

  useEffect(() => {
    getActivity();
  }, [selectedYear]);

  useEffect(() => {
    setFiltered(data);
  }, [data]);

  return (
    <div className="border rounded-xl bg-white">
      <div className="flex justify-between mx-5 mt-5">
        <p className="font-semibold text-xl">Activity Tracker</p>
        <div className="flex items-center gap-3">
          <YearPicker
            value={selectedYear}
            onChange={(year) => setSelectedYear(year)}
          />

          <div className="md:w-auto w-40">
            <Search data={data} setFiltered={setFiltered} />
          </div>
        </div>
      </div>

      <div className="mt-5">
        <SkeletonTable
          columns={updatedColumns}
          data={filtered}
          isLoading={isLoading}
          pagination={true}
          onRowClick={(record) => handleRedirect(record)}
        />
      </div>
    </div>
  );
};

export default Activity;
